

















































import {
  defineComponent, useContext,
} from '@nuxtjs/composition-api';
import PictureItem from "~/components/Palmers/BaseComponents/Picture/PictureItem.vue";

export default defineComponent({
  name: 'PalmersActions',
  components: {
    PictureItem
  },
  props: {
    content: {
      type: [Array, Object, Boolean],
      require: true
    },
    imageType: {
      type: String,
      default() {
        return 'palmers_actions'
      }
    }
  },
  setup() {
    const {$vsf, $config} = useContext();

    return {
      magentoBaseUrl: $vsf.$magento.config.magentoBaseUrl,
      magentoMediaUrl: $config.magentoMediaUrl
    }
  },
  methods: {
    getSource() {
      if(this.source === 'default') {
        return this.magentoBaseUrl;
      }else {
        return this.magentoMediaUrl;
      }
    },
    getLinkTag(link) {
      let tag = 'nuxt-link';

      if(!link) return tag;

      if(link.indexOf('http') > -1) {
        tag = 'a'
      }

      return tag;
    }
  }
});
